export default "__VITE_ASSET__kbZlhJxc__"